import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "case-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__delimiter" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "page-items__expand" }, null, -1)
const _hoisted_4 = { class: "case-header__right" }
const _hoisted_5 = {
  key: 1,
  class: "cases-page__loading"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButtonGroup = _resolveComponent("NButtonGroup")!
  const _component_FilterSection = _resolveComponent("FilterSection")!
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_SortDropdown = _resolveComponent("SortDropdown")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NInput = _resolveComponent("NInput")!
  const _component_NTable = _resolveComponent("NTable")!
  const _component_EmptyPage = _resolveComponent("EmptyPage")!
  const _component_EditCasePage = _resolveComponent("EditCasePage")!
  const _component_NLoadingCircle = _resolveComponent("NLoadingCircle")!
  const _component_ListPage = _resolveComponent("ListPage")!

  return (_openBlock(), _createBlock(_component_ListPage, {
    state: _ctx.state,
    "onUpdate:scrollBottom": _ctx.scrollBottomHandler,
    statistics: false
  }, {
    filters: _withCtx(() => [
      _createVNode(_component_FilterSection, {
        "data-qa": `${_ctx.dataQa}.filter-section`,
        filter: _ctx.module.filter,
        schemeSmall: _ctx.smallFilterLayout,
        schemeLarge: _ctx.largeFilterLayout,
        hasPinnedFields: "",
        defaultPinnedFields: ['has_unacknowledged_case_clusters']
      }, {
        small: _withCtx(() => [
          _createVNode(_component_NButtonGroup, {
            "data-qa": `${_ctx.dataQa}.filter-status`,
            items: _ctx.statusFilterItems,
            modelValue: _ctx.module.filter.current.status,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.module.filter.current.status) = $event))
          }, null, 8, ["data-qa", "items", "modelValue"])
        ]),
        _: 1
      }, 8, ["data-qa", "filter", "schemeSmall", "schemeLarge"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_Statistics, { module: _ctx.module }, null, 8, ["module"])
        ]),
        _hoisted_2,
        _createVNode(_component_SortDropdown, {
          items: _ctx.sortTypes,
          modelValue: _ctx.module.filter.current.ordering,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event))
        }, null, 8, ["items", "modelValue"]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (_ctx.selectedItems.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.modelAcl.update && _ctx.selectedItemsContainArchive)
                  ? (_openBlock(), _createBlock(_component_NButton, {
                      key: 0,
                      label: _ctx.$t('common.open_all_selected', 'f'),
                      onAction: _ctx.openAll,
                      type: "secondary",
                      icon: "open_folder",
                      "data-qa": "cases.archive_all"
                    }, null, 8, ["label", "onAction"]))
                  : _createCommentVNode("", true),
                (_ctx.modelAcl.update && _ctx.selectedItemsContainOpen)
                  ? (_openBlock(), _createBlock(_component_NButton, {
                      key: 1,
                      label: _ctx.$t('common.archive_all_selected', 'f'),
                      onAction: _ctx.archiveAll,
                      type: "secondary",
                      icon: "archive",
                      "data-qa": "cases.archive_all"
                    }, null, 8, ["label", "onAction"]))
                  : _createCommentVNode("", true),
                (_ctx.modelAcl.update)
                  ? (_openBlock(), _createBlock(_component_NButton, {
                      key: 2,
                      label: _ctx.$t('common.delete', 'f'),
                      onAction: _ctx.deleteAll,
                      type: "secondary",
                      icon: "delete"
                    }, null, 8, ["label", "onAction"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_NInput, {
            class: "case-header__search",
            placeholder: _ctx.$t('common.search', 'f'),
            modelValue: _ctx.module.filter.current.name_contains,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.module.filter.current.name_contains) = $event)),
            clearable: ""
          }, null, 8, ["placeholder", "modelValue"]),
          _createVNode(_component_NButton, {
            icon: "add",
            onClick: _ctx.addNew,
            disabled: !_ctx.modelAcl.add
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cases.new_case', 'f')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ])
    ]),
    items: _withCtx(() => [
      _createVNode(_component_NTable, {
        "data-qa": `${_ctx.dataQa}.table`,
        class: "cases-table",
        columns: _ctx.columns,
        content: _ctx.module.items,
        "selected-items-ids": _ctx.selectedItemIds,
        "compute-row-class": _ctx.computeRowClass,
        onSort: _ctx.handleTableSort,
        onCellClick: _ctx.cellClickHandler
      }, null, 8, ["data-qa", "columns", "content", "selected-items-ids", "compute-row-class", "onSort", "onCellClick"])
    ]),
    overlay: _withCtx(() => [
      (_ctx.module.loaded)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.showNewCase)
              ? (_openBlock(), _createBlock(_component_EmptyPage, {
                  key: 0,
                  "data-qa": `${_ctx.dataQa}.empty-page`,
                  i18n_title: "cases.new_case",
                  i18n_description: "cases.new_case_description",
                  i18n_buttonText: "cases.create_first_case",
                  imageType: "--image-empty-case",
                  onCreate: _ctx.addNew
                }, null, 8, ["data-qa", "onCreate"]))
              : (_openBlock(), _createBlock(_component_EditCasePage, {
                  key: 1,
                  ref: "editCase",
                  saving: _ctx.module.saving,
                  onSave: _ctx.saveNew,
                  onClose: _ctx.resetNewItem
                }, null, 8, ["saving", "onSave", "onClose"]))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_NLoadingCircle)
          ]))
    ]),
    "items-empty": _withCtx(() => [
      _hoisted_6
    ]),
    _: 1
  }, 8, ["state", "onUpdate:scrollBottom"]))
}